import React from 'react'
import DatePicker, { DatePickerProps } from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

import { CustomDatePickerInput } from './CustomDatePickerInput'
import './DatePickerWithIcon.scss'
import { DisableTooltip } from '@/shared/ui/disable-tooltip'

export type DatePickerWithIconProps = {
    selected: Date | undefined
    isBlue?: boolean
    isDisabled?: boolean
    onChange: (date: Date | undefined) => void
    dateFormat?: string
    className?: string
    dropdownMode?: 'scroll' | 'select'
    error?: boolean
    disabledMessage?: string
    tooltipEnabled?: boolean
} & Pick<DatePickerProps, 'startDate' | 'minDate' | 'maxDate' | 'endDate'>

export const DatePickerWithIcon: React.FC<DatePickerWithIconProps> = ({
    selected,
    isBlue,
    isDisabled,
    onChange,
    dateFormat = 'dd.MM.yy',
    className,
    dropdownMode = 'scroll',
    error,
    disabledMessage = '',
    tooltipEnabled = false,
    ...props
}) => {
    return (
        <DisableTooltip enabled={tooltipEnabled} message={disabledMessage}>
            <DatePicker
                disabled={!!isDisabled}
                selected={selected}
                onChange={(date) => {
                    onChange(date ?? undefined)
                }}
                dateFormat={dateFormat}
                dropdownMode={dropdownMode}
                customInput={
                    <CustomDatePickerInput
                        isBlueBorder={!!isBlue}
                        className={className}
                        error={error}
                    />
                }
                portalId="datepicker"
                {...props}
            />
        </DisableTooltip>
    )
}
